import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import Layout from "./pages/Dashboard/Layout";
import DashboardHome from "./pages/Dashboard/components/DashboardHome";
import PreviousYearPaper from "./pages/Dashboard/components/PreviousYearPaper";
import ExamInstructions from "./pages/Dashboard/previous-paper/ExamInstructions";
import TestInstructions from "./pages/Dashboard/previous-paper/TestInstructions";
import TestInterface from "./pages/Dashboard/previous-paper/TestInterface";
import Practice from "./pages/Dashboard/components/Practice";
import Result from "./pages/Dashboard/previous-paper/result/Result";
import FreeQuizzes from "./pages/Dashboard/components/FreeQuizzes";
import SubscriptionPage from "./pages/Dashboard/components/SubscriptionPage";
import PrimeSubscription from "./pages/Dashboard/components/PrimeSubscription";
import TestInterfaceSecond from "./pages/Dashboard/TestInterface2/TestInterfaceSecond";
import SettingsPage from "./pages/Dashboard/settings/SettingsPage";
import MockExamInterface from "./pages/Dashboard/free-quizzes-data/MockExamInterface";
import QuizResult from "./pages/Dashboard/free-quizzes-data/QuizResult"


function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/dashboard" element={<Layout />}>
        <Route index element={<DashboardHome />} />
        <Route path="previous-year-papers" element={<PreviousYearPaper />} />
        <Route path="practice" element={<Practice />} />
        <Route path="free-quizzes" element={<FreeQuizzes />} />
        <Route path="subscription" element={<SubscriptionPage />} />
        <Route path="prime-subscription" element={<PrimeSubscription />} />
        <Route path="profile" element={<SettingsPage />} />
      </Route>
      <Route path="/exam-instructions" element={<ExamInstructions />} />
      <Route path="/test-instructions" element={<TestInstructions />} />
      <Route path="/test-interface" element={<TestInterface />} />
      <Route path="/quiz/:id?" element={<MockExamInterface />} />
      <Route path="/quiz-result/:attemptId?" element={<QuizResult />} />
      <Route path="/test-result" element={<Result />} />
      <Route path="/test-interface-second" element={<TestInterfaceSecond />} />
    </Routes>
  );
}

export default App;
